function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2227 912",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M357.279,637.271c75.647,-0 137.063,61.416 137.063,137.063c-0,75.647 -61.416,137.063 -137.063,137.063c-75.648,0 -137.064,-61.416 -137.064,-137.063c0,-75.647 61.416,-137.063 137.064,-137.063Zm1531.2,-0c75.647,-0 137.063,61.416 137.063,137.063c0,75.647 -61.416,137.063 -137.063,137.063c-75.647,0 -137.063,-61.416 -137.063,-137.063c-0,-75.647 61.416,-137.063 137.063,-137.063Zm-1701.03,137.063l-150.535,-0c-9.789,-0 -19.177,-3.889 -26.098,-10.811c-6.922,-6.922 -10.811,-16.31 -10.811,-26.099l0,-663.605c-0,-19.578 7.777,-38.354 21.621,-52.198c13.844,-13.844 32.62,-21.621 52.198,-21.621l1712.52,0c36.12,0 69.969,17.617 90.692,47.2l155.949,222.631c10.423,14.88 24.348,26.967 40.546,35.195l112.981,57.387c24.779,12.586 40.389,38.023 40.389,65.815l-0,309.196c-0,9.789 -3.889,19.177 -10.811,26.099c-6.922,6.922 -16.31,10.811 -26.099,10.811l-131.673,-0c-0,-93.734 -76.101,-169.835 -169.835,-169.835c-93.734,0 -169.835,76.101 -169.835,169.835l-1191.53,-0c0,-93.734 -76.1,-169.835 -169.834,-169.835c-93.735,0 -169.835,76.101 -169.835,169.835Zm1565.13,-689.182l-115.703,-0c-20.384,-0 -36.909,16.525 -36.909,36.909l-0,59.958c-0,29.366 11.666,57.531 32.431,78.296c20.766,20.766 48.93,32.432 78.297,32.432l204.445,-0c4.129,-0 7.915,-2.298 9.822,-5.961c1.906,-3.663 1.616,-8.083 -0.753,-11.465l-111.169,-158.702c-13.815,-19.723 -36.381,-31.467 -60.461,-31.467Z",
    style: {
      fill: "#141f2a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/OtherIcon.fb5043341afec914fb7cab44ffbc4222.svg";
export { ForwardRef as ReactComponent };